export default class Flags {
}
Flags.worker = true;
//# sourceMappingURL=Flags.js.map